module.exports = __webpack_public_path__ + "img/health0.5f7e65ac.jpg";